<template>
  <div id="zgs">
    <table border="1" cellspacing="0" cellpadding="0">
      <tbody>
      <tr>
        <td>公司名称</td>
        <td>{{company.GSMC}}</td>
      </tr>
      <tr>
        <td>成立时间</td>
        <td>{{company.CLSJ}}</td>
      </tr>
      <tr>
        <td>注册地址</td>
        <td>{{company.ZCDZ}}</td>
      </tr>
      <tr>
        <td>注册资本</td>
        <td>{{company.ZCZB}}</td>
      </tr>
      <tr>
        <td>股权结构</td>
        <td>{{company.GQJG}}</td>
      </tr>
      <tr>
        <td>法定代表人</td>
        <td>{{company.FR}}</td>
      </tr>
      <tr>
        <td>经营范围</td>
        <td>{{company.JYFW}}</td>
      </tr>
      <tr>
        <td>备案试点业务</td>
        <td>{{company.BASD}}</td>
      </tr>
      <tr>
        <td>是否开立期货交易账户</td>
        <td>{{company.QHZH}}</td>
      </tr>
      <tr>
        <td>开户期货公司</td>
        <td>{{company.KHGS}}</td>
      </tr>
      <tr>
        <td>客户投诉电话</td>
        <td>{{company.TSDH}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ajax from '@/common/ajax/ajax'

export default {
  name: 'zgs',
  data () {
    return {
      company: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      ajax.getZGSMes().then(
        data => {
          this.company = data[0]
        }
      )
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #zgs
    table
      margin 20px 0;
      td
        padding 5px
      td:first-child
        min-width 110px
        color #323232
        font-size 16px
        font-weight bold
</style>



// WEBPACK FOOTER //
// zgs.vue?e9b4a7de